import { useState } from 'react';
import { OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { teamService } from '../../services';

const TeamGroupsPopover = ({ userId }) => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const fetchGroups = async () => {
    if (loaded || loading) return;
    setLoading(true);
    teamService
      .get_team_group_list({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        teamMemberId: userId,
        onlyGroupName: true,
      })
      .then((response) => {
        if (response.data) {
          setGroups(response.data || []);
          setLoaded(true);
          setLoading(false);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const popover = (
    <Popover id="team-groups-popover" className="ms-1 px-3 py-2">
      <Popover.Title>Groups</Popover.Title>
      <Popover.Content>
        {loading && <Spinner animation="border" size="sm" />}

        {!loading && groups.length === 0 && (
          <div className="text-muted">No teams found</div>
        )}

        {!loading && groups.length > 0 && (
          <ul className="ms-0 mb-0 list-unstyled text-dark">
            {groups.map((group) => (
              <li key={group._id}>
                • {group.name}{' '}
                {group.role && group.role === 'admin' && (
                  <span className="text-muted">(admin)</span>
                )}
              </li>
            ))}
          </ul>
        )}
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      overlay={popover}
      rootClose
      onToggle={(show) => show && fetchGroups()}
    >
      <small
        role="button"
        className="text-muted text-decoration-underline mb-3"
        style={{ cursor: 'pointer' }}
      >
        View Groups
      </small>
    </OverlayTrigger>
  );
};

TeamGroupsPopover.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default TeamGroupsPopover;
